var ButtonData_Type = /* @__PURE__ */ ((ButtonData_Type2) => {
  ButtonData_Type2["LINK"] = "LINK";
  ButtonData_Type2["ACTION"] = "ACTION";
  ButtonData_Type2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return ButtonData_Type2;
})(ButtonData_Type || {});
var ButtonData_Styles_Background_Type = /* @__PURE__ */ ((ButtonData_Styles_Background_Type2) => {
  ButtonData_Styles_Background_Type2["COLOR"] = "COLOR";
  ButtonData_Styles_Background_Type2["GRADIENT"] = "GRADIENT";
  ButtonData_Styles_Background_Type2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return ButtonData_Styles_Background_Type2;
})(ButtonData_Styles_Background_Type || {});
export {
  ButtonData_Styles_Background_Type,
  ButtonData_Type
};
//# sourceMappingURL=plugin_button.enums.js.map
